var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "document-page" },
    [
      _vm._m(0),
      _c(
        "el-card",
        {
          staticClass: "filter-card",
          attrs: { shadow: "never", "body-style": { padding: "18px 22px" } },
        },
        [
          _c(
            "el-form",
            {
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "单据搜索" } },
                [
                  _c("el-input", {
                    staticClass: "search",
                    attrs: {
                      clearable: "",
                      placeholder: "编号 / 标题 / 项目 / 客户 / 小区",
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleSearch($event)
                      },
                    },
                    model: {
                      value: _vm.searchForm.keywords,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.searchForm,
                          "keywords",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "searchForm.keywords",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "单据类型" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "全部类型" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.searchForm.documentType,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "documentType", $$v)
                        },
                        expression: "searchForm.documentType",
                      },
                    },
                    _vm._l(_vm.typeOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "流程状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "全部状态" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.searchForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "status", $$v)
                        },
                        expression: "searchForm.status",
                      },
                    },
                    _vm._l(_vm.statusOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-checkbox",
                    {
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.searchForm.overdue,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "overdue", $$v)
                        },
                        expression: "searchForm.overdue",
                      },
                    },
                    [_vm._v("只看超时")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("查询")]
                  ),
                  _c("el-button", { on: { click: _vm.handleReset } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "metrics" }, [
        _c("div", [
          _c("span", [_vm._v("单据总数")]),
          _c("strong", [_vm._v(_vm._s(_vm.tableData.total))]),
          _c("small", [_vm._v("DOCUMENTS")]),
        ]),
        _c("div", { staticClass: "warning" }, [
          _c("span", [_vm._v("待审批 / 签署 / 整改 / 验收")]),
          _c("strong", [_vm._v(_vm._s(_vm.pendingCount))]),
          _c("small", [_vm._v("PENDING")]),
        ]),
        _c("div", { staticClass: "success" }, [
          _c("span", [_vm._v("当前页已闭环")]),
          _c("strong", [_vm._v(_vm._s(_vm.completedCount))]),
          _c("small", [_vm._v("COMPLETED")]),
        ]),
        _c("div", { class: _vm.overdueCount ? "danger" : "" }, [
          _c("span", [_vm._v("当前页超时")]),
          _c("strong", [_vm._v(_vm._s(_vm.overdueCount))]),
          _c("small", [_vm._v("OVERDUE")]),
        ]),
      ]),
      _c(
        "el-card",
        {
          staticClass: "table-card",
          attrs: { shadow: "never", "body-style": { padding: "0 20px 20px" } },
        },
        [
          _c(
            "div",
            { staticClass: "title" },
            [
              _c("div", [
                _c("strong", [_vm._v("确认 · 延期 · 变更 · 整改 · 验收台账")]),
                _c("span", [_vm._v("点击查看单据详情、签署、整改与验收结果")]),
              ]),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", icon: "el-icon-refresh" },
                  on: { click: _vm.getList },
                },
                [_vm._v("刷新")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                data: _vm.tableData.data,
                size: "mini",
                "highlight-current-row": "",
              },
              on: { "row-click": _vm.openDetail },
            },
            [
              _c("el-table-column", {
                attrs: { label: "单据编号", "min-width": "210" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", { staticClass: "document-no" }, [
                          _vm._v(_vm._s(row.document.documentNo)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "类型 / 标题", "min-width": "210" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          { staticClass: "two-line" },
                          [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  size: "mini",
                                  type: _vm.typeTag[row.document.documentType],
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.typeText[row.document.documentType]
                                  )
                                ),
                              ]
                            ),
                            _c("strong", [_vm._v(_vm._s(row.document.title))]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "工地项目", "min-width": "190" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("div", { staticClass: "two-line" }, [
                          _c("strong", [
                            _vm._v(_vm._s(row.project.projectName)),
                          ]),
                          _c("span", [
                            _vm._v(
                              _vm._s(row.property.communityName) +
                                " · " +
                                _vm._s(row.customer.name)
                            ),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "关联节点", "min-width": "125" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(_vm._s(row.document.scheduleName || "未关联")),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "金额变动", width: "115", align: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "span",
                          {
                            class: Number(row.document.amountDelta)
                              ? "change"
                              : "muted",
                          },
                          [_vm._v(_vm._s(_vm.money(row.document.amountDelta)))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "工期变动", width: "100", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "span",
                          {
                            class: Number(row.document.daysDelta)
                              ? "change"
                              : "muted",
                          },
                          [_vm._v(_vm._s(_vm.days(row.document.daysDelta)))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "签署", width: "135", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("div", { staticClass: "sign-cell" }, [
                          _c("i", {
                            class: row.document.issuerSigned ? "done" : "",
                          }),
                          _vm._v("发起人 "),
                          _c("i", {
                            class: row.document.customerSigned ? "done" : "",
                          }),
                          _vm._v("业主"),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "状态", width: "115", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type: row.document.overdue
                                ? "danger"
                                : _vm.statusTag[row.document.status],
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                row.document.overdue
                                  ? "已超时"
                                  : _vm.statusText[row.document.status]
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "更新时间", width: "155" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(row.document.updateTime))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "115",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.openDetail(row)
                              },
                            },
                          },
                          [_vm._v("查看")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "text",
                              size: "mini",
                              loading: _vm.downloadingId === row.document.id,
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.downloadPdf(row)
                              },
                            },
                          },
                          [_vm._v("PDF")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-sizes": _vm.$constants.page.limit,
                  "page-size": _vm.searchForm.limit,
                  "current-page": _vm.searchForm.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.detail
        ? _c(
            "el-drawer",
            {
              attrs: {
                visible: _vm.drawerVisible,
                size: "570px",
                "custom-class": "document-drawer",
                "with-header": false,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.drawerVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "drawer-head" },
                [
                  _c("div", [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.typeText[_vm.detail.document.documentType]) +
                          " · " +
                          _vm._s(_vm.detail.document.documentNo)
                      ),
                    ]),
                    _c("h3", [_vm._v(_vm._s(_vm.detail.document.title))]),
                    _c("p", [
                      _vm._v(
                        _vm._s(_vm.detail.project.projectName) +
                          " · " +
                          _vm._s(_vm.detail.property.communityName)
                      ),
                    ]),
                  ]),
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        type: _vm.statusTag[_vm.detail.document.status],
                      },
                    },
                    [_vm._v(_vm._s(_vm.statusText[_vm.detail.document.status]))]
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "drawer-body" }, [
                _c("div", { staticClass: "detail-grid" }, [
                  _c("div", [
                    _c("span", [_vm._v("客户")]),
                    _c("strong", [_vm._v(_vm._s(_vm.detail.customer.name))]),
                  ]),
                  _c("div", [
                    _c("span", [_vm._v("发起人")]),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.detail.document.issuerName)),
                    ]),
                  ]),
                  _c("div", [
                    _c("span", [_vm._v("关联节点")]),
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.detail.document.scheduleName || "未关联")
                      ),
                    ]),
                  ]),
                  _c("div", [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.detail.document.documentType === "acceptance"
                            ? "验收负责人"
                            : "责任人"
                        )
                      ),
                    ]),
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.detail.document.responsibleName || "未指定")
                      ),
                    ]),
                  ]),
                  _c("div", [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.detail.document.documentType === "rectification"
                            ? "整改轮次"
                            : _vm.detail.document.documentType === "acceptance"
                            ? "验收类型"
                            : "金额变动"
                        )
                      ),
                    ]),
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.detail.document.documentType === "rectification"
                            ? (_vm.detail.document.rectificationCount || 0) +
                                " 次"
                            : _vm.detail.document.documentType === "acceptance"
                            ? _vm.acceptanceType(_vm.detail.document.reasonCode)
                            : _vm.money(_vm.detail.document.amountDelta)
                        )
                      ),
                    ]),
                  ]),
                  _c("div", [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.detail.document.documentType === "rectification"
                            ? "整改期限"
                            : _vm.detail.document.documentType === "acceptance"
                            ? "验收日期"
                            : "工期变动"
                        )
                      ),
                    ]),
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          ["rectification", "acceptance"].includes(
                            _vm.detail.document.documentType
                          )
                            ? _vm.detail.document.requiredActionTime || "未设置"
                            : _vm.days(_vm.detail.document.daysDelta)
                        )
                      ),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "detail-block" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.detail.document.documentType === "acceptance"
                          ? "验收项目"
                          : "单据内容"
                      )
                    ),
                  ]),
                  _c("p", [_vm._v(_vm._s(_vm.detail.document.content))]),
                ]),
                _vm.detail.document.reasonText
                  ? _c("div", { staticClass: "detail-block" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.detail.document.documentType === "acceptance"
                              ? "验收标准"
                              : "原因说明"
                          )
                        ),
                      ]),
                      _c("p", [_vm._v(_vm._s(_vm.detail.document.reasonText))]),
                    ])
                  : _vm._e(),
                _vm.detail.document.lastRectificationRemark
                  ? _c(
                      "div",
                      { staticClass: "detail-block rectification-result" },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.detail.document.documentType === "acceptance"
                                ? "最近复验整改"
                                : "最近整改结果"
                            )
                          ),
                        ]),
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.detail.document.lastRectificationRemark)
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _c("div", { staticClass: "signature-board" }, [
                  _c(
                    "div",
                    { class: _vm.detail.document.issuerSigned ? "signed" : "" },
                    [
                      _c("i", { staticClass: "el-icon-edit-outline" }),
                      _c("strong", [_vm._v("发起人签字")]),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.detail.document.issuerSigned
                              ? "已签署归档"
                              : "等待签署"
                          )
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      class: _vm.detail.document.customerSigned ? "signed" : "",
                    },
                    [
                      _c("i", { staticClass: "el-icon-user" }),
                      _c("strong", [_vm._v("业主签字")]),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.detail.document.customerSigned
                              ? "已登记归档"
                              : "等待登记"
                          )
                        ),
                      ]),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "deadline" }, [
                  _c("span", [_vm._v("要求处理时间")]),
                  _c(
                    "strong",
                    { class: _vm.detail.document.overdue ? "overdue" : "" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.detail.document.requiredActionTime || "未设置"
                        )
                      ),
                    ]
                  ),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "drawer-actions" },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.drawerVisible = false
                        },
                      },
                    },
                    [_vm._v("关闭")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-download",
                        loading: _vm.downloadingId === _vm.detail.document.id,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.downloadPdf(_vm.detail)
                        },
                      },
                    },
                    [_vm._v("下载 PDF 单据")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hero" }, [
      _c("div", [
        _c("span", [_vm._v("SITE DOCUMENT LEDGER")]),
        _c("h2", [_vm._v("工地业务单据台账")]),
        _c("p", [
          _vm._v(
            "集中追踪确认、延期、变更、整改与验收单的审批、双签和闭环状态。"
          ),
        ]),
      ]),
      _c("div", { staticClass: "hero-tags" }, [
        _c("b", [_vm._v("审批留痕")]),
        _c("b", [_vm._v("双签归档")]),
        _c("b", [_vm._v("PDF 下载")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }